import { useEffect, useRef } from 'react';

// A soft pointer glow adds depth on fine-pointer devices without blocking input.
export function CursorGlow() {
  const glowRef = useRef(null);
  const frameRef = useRef(0);
  const pointerRef = useRef({ x: 0, y: 0 });

  useEffect(() => {
    if (!window.matchMedia('(pointer: fine)').matches) return undefined;

    const moveGlow = (event) => {
      pointerRef.current = { x: event.clientX, y: event.clientY };
      if (frameRef.current) return;

      frameRef.current = window.requestAnimationFrame(() => {
        glowRef.current?.style.setProperty('--pointer-x', `${pointerRef.current.x}px`);
        glowRef.current?.style.setProperty('--pointer-y', `${pointerRef.current.y}px`);
        frameRef.current = 0;
      });
    };

    window.addEventListener('pointermove', moveGlow, { passive: true });
    return () => {
      window.removeEventListener('pointermove', moveGlow);
      if (frameRef.current) window.cancelAnimationFrame(frameRef.current);
    };
  }, []);

  return <div ref={glowRef} className="cursor-glow" aria-hidden="true" />;
}
